module.exports = __webpack_public_path__ + "static/long_distance-95612b680ea398a5880aa6d7c7018c87.jpg";